import React, {useRef, useState} from 'react'

const IframeContent = props => {
  const {body, width} = props
  const iframe = useRef()
  const [height, setHeight] = useState("0px");

  const htmlBody = body.replace(/target\s*=\s*['"]_(self|top)['"]/ig, "target='_blank'")

  const onLoad = () => {
    const document = iframe.current?.contentDocument;
    if (document) {
      const new_style_element = document.createElement("style");
      new_style_element.textContent = "body { font-family: Calibri,sans-serif; font-size:11pt }"
      document.head.appendChild(new_style_element);
      const new_base_element = document.createElement("base");
      new_base_element.target = "_blank"
      document.head.appendChild(new_base_element);
      setHeight((parseInt(document.documentElement.scrollHeight)+ 100).toString() + 'px')
    }
  }

  // useEffect(() => {
  //   const document = iframe.current?.contentDocument;
  //   if (document) {
  //     document.open()
  //     document.write(htmlBody)
  //     document.close()
  //     const new_style_element = document.createElement("style");
  //     new_style_element.textContent = "body { font-family: Calibri,sans-serif; font-size:11pt }"
  //     document.head.appendChild(new_style_element);
  //     const new_base_element = document.createElement("base");
  //     new_base_element.target = "_blank"
  //     document.head.appendChild(new_base_element);
  //   }
  // }, [body])

  return (
    <iframe 
      srcDoc={htmlBody} 
      title="email" 
      width={width || '100%'} 
      height={height} 
      onLoad={onLoad} 
      frameBorder={0} 
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" 
      ref={iframe}
    />
  )
}

export default IframeContent
